// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"NumberOneSection_cardContainer__8d3WQ","cardBox":"NumberOneSection_cardBox__YRqNx"};